/**
 * DOM Changed view trigger
 * @module
 */

var DocumentEnv = require('core/env/document');
var enums = require('core/constants/enums');
var EventEmitter = require('core/event_emitter');
var Observer = require('core/observer');
var View = require('core/view');
var DOM_CHANGED = 'DOMChanged';

var pluginTriggerDomchanged = {
  token: undefined,
  /**
   * Monitor the DOM for changes, and emit a DOMChanged event upon changes
   */
  setUpObserver: function() {
    Observer.createDOMChangedObserver();

    this.token = EventEmitter.on({
      filter: {
        type: 'viewTrigger',
        name: 'DOMChanged'
      },
      handler: function() {
        View.getViewsAndActivate(enums.ViewActivationTypes.DOMChanged);
      },
    });
  },

  turnOffObserver: function() {
    EventEmitter.off(this.token);
  },
};

module.exports = function(PluginManager) {
  if (DocumentEnv.isReady()) {
    pluginTriggerDomchanged.setUpObserver();
  } else {
    DocumentEnv.addReadyHandler(pluginTriggerDomchanged.setUpObserver);
  }

  PluginManager.registerViewTrigger(DOM_CHANGED, pluginTriggerDomchanged);
};

if (__TEST__) {
  module.exports.plugin = pluginTriggerDomchanged;
}
